export const isLoggedIn = state => {
  return state.LoggedIn;
};

export const isFavoriteLoading = state => {
  return state.favoriteLoading;
};

export const getError = state => {
  return { error: state.error, errorMessage: state.errorMessage };
};

export const getSuccess = state => {
  return { success: state.success, successMessage: state.successMessage };
};

export const getAuthError = state => {
  return { error: state.authError, authErrorMessage: state.authErrorMessage };
};

export const isValidToken = state => {
  return state.validToken;
};

export const getRoleToken = state => {
  return state.roleToken;
};

export const getUserInfo = state => {
  return state.userInfo;
};

export const fetching = state => {
  return state.fetching;
};

export const getUbication = state => {
  return state.ubication;
};

export const getListaCarreras = state => {
  return state.carreras;
};

export const getListaIndustrias = state => {
  return state.industrias;
};

export const getRequestResult = state => {
  return state.requestResult;
};

export const getResultadosGlobalesTest = state => {
  return state.resultadosGlobalesTest;
};

export const getStateTest = state => {
  return state.stateTest;
};

export const getNextQuestionTest = state => {
  return state.nextQuestionTest;
};

export const getListaPublicaciones = state => {
  return state.listaPublicaciones;
};

export const getPublicacionSeleccionada = state => {
  return state.publicacionSeleccionada;
};
